import axios from "./axios"

class Update {
  async device(device) {
    return axios()
      .post("/api/set/device/update", device)
      .catch(err => _$.error(err))
  }
  async guest(guest) {
    return axios()
      .post("/api/set/guest/update", guest)
      .catch(err => _$.error(err))
  }
}

export default new Update()
